import { render } from "./PreviewEditLink.vue?vue&type=template&id=830d96b6&scoped=true"
import script from "./PreviewEditLink.vue?vue&type=script&lang=js"
export * from "./PreviewEditLink.vue?vue&type=script&lang=js"

import "./PreviewEditLink.vue?vue&type=style&index=0&id=830d96b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-830d96b6"]])

export default __exports__